<template>
  <div>
    <div class="page-head">
      <div>
        <h3>Total Stock</h3>
        <p class="page-head-sub">Current value and size of the stock</p>
      </div>
    </div>
    <div class="w-100 position-relative" v-if="loading">
      <div class="w-100 mt-5 position-absolute text-center">
        <b-icon class="text-light" icon="arrow-clockwise" animation="spin" font-scale="3"></b-icon>
      </div>
    </div>
    <div class="stat-grid">
      <div class="stat-tile success" v-if="!loading">
        <p class="stat-label">Total stock value</p>
        <p class="stat-value total">{{Math.round(data.totalMinPrice).toLocaleString('no') || 0}} PLN</p>
      </div>
      <div v-if="data.uniqueProducts" class="stat-tile">
        <p class="stat-label">Unique parts in stock</p>
        <p class="stat-value">{{data.uniqueProducts.toLocaleString('en')}}</p>
      </div>
      <div v-if="data.totalLocalCount" class="stat-tile">
        <p class="stat-label">Total parts count in stock</p>
        <p class="stat-value">{{data.totalLocalCount.toLocaleString('en')}}</p>
      </div>
    </div>
    <div v-if="history.length">
      <h5 class="section-label">Stock history · last 30 weeks</h5>
      <b-table class="text-center" striped hover :items="history" :fields="historyFields"></b-table>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import fixed from '../../fixed';

export default {
  name: 'TotalStock',
  data: () => ({
    loading: false,
    data: {
      totalMinPrice: 0,
      uniqueProducts: 0,
      totalLocalCount: 0,
    },
    history: [],
    historyFields: [
      { key: 'recordedAt', formatter: (value) => moment(value).format('DD.MM.yyyy HH.mm') },
      { key: 'uniqueProducts', label: 'Unique', formatter: (value) => value.toLocaleString('no') || 0 },
      { key: 'totalLocalCount', label: 'Total Count', formatter: (value) => value.toLocaleString('no') || 0 },
      {
        key: 'totalMinPrice',
        label: 'Total Stock Value PLN',
        formatter: (value) => Math.round(value).toLocaleString('no') || 0,
      },
    ],
  }),
  async mounted() {
    this.loading = true;

    try {
      // Get total current
      const { data } = await axios.get(
        `${fixed.API_URL}/admin/total-stock-value`,
        { withCredentials: true },
      );

      const [result] = data || {};
      this.data = result;

      // Get history
      const { data: history } = await axios.get(
        `${fixed.API_URL}/admin/stock-history`,
        { withCredentials: true },
      );
      if (history && history.length) this.history = history;
    } catch (error) {
      console.error(error); // eslint-disable-line
    }
    this.loading = false;
  },
  methods: {
  },
};
</script>

<style scoped>
.total {
  font-size: 2.2rem;
}
</style>
